'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".TrackingEventsLastUpdated-module_refreshContainer__iwXe0{align-items:center;display:flex}.TrackingEventsLastUpdated-module_refreshIconWrapper__J4487{display:flex;margin-left:.25rem}";
var styles = {"refreshContainer":"TrackingEventsLastUpdated-module_refreshContainer__iwXe0","refreshIconWrapper":"TrackingEventsLastUpdated-module_refreshIconWrapper__J4487"};
styleInject["default"](css_248z, '613cd7b2-890a-4d8b-a0e3-45333f1d987e');

exports["default"] = styles;
